var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.dialog, "max-width": "1000" },
      on: {
        "click:outside": _vm.close,
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _vm.payslip || _vm.loader
        ? _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v(_vm._s(_vm.fileName)),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", disabled: !_vm.url },
                      on: { click: _vm.download },
                    },
                    [_c("v-icon", [_vm._v("mdi-download")])],
                    1
                  ),
                  _c(
                    "v-btn",
                    { attrs: { icon: "" }, on: { click: _vm.close } },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-card-text", [
                _vm.loading
                  ? _c(
                      "div",
                      { staticClass: "text-center py-10" },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "primary" },
                        }),
                      ],
                      1
                    )
                  : _vm.url
                  ? _c("iframe", {
                      staticStyle: {
                        width: "100%",
                        height: "75vh",
                        border: "none",
                      },
                      attrs: { src: _vm.url },
                    })
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }